<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item
                :to="{
                    path: '/academic_Management/academic_font_management/academic_referee_system',
                }"
                >裁判系统</el-breadcrumb-item
            >
            <el-breadcrumb-item>城市赛裁判系统</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <el-row>
            <el-col :span="24" align="right">
                <el-button type="warning" plain icon="el-icon-warning-outline" size="mini" @click="descVisible = true">使用说明</el-button>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-col :span="12">
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span>条件筛选</span>
                        </el-col>
                    </el-row>
                    <el-form
                        ref="queryFormRef"
                        :model="queryForm"
                        :rules="queryFormRule"
                        label-width="80px"
                    >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="赛季" prop="season" size="small">
                                    <el-select
                                        size="small"
                                        placeholder="请选择赛季"
                                        style="width: 100%"
                                        v-model="queryForm.season"
                                    >
                                        <el-option
                                            v-for="item in dict_season"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="赛区" prop="districtId" size="small">
                                    <el-select
                                        size="small"
                                        style="width: 100%"
                                        v-model="queryForm.districtId"
                                        @change="matchInfoShow = false"
                                        ref="matchTypeRef"
                                    >
                                        <el-option
                                            v-for="item in dict_district"
                                            :key="item.id"
                                            :label="item.districtName"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="比赛组别" prop="level" size="small" style="margin-bottom: 0;">
                                    <el-select
                                        style="width: 100%"
                                        size="small"
                                        v-model="queryForm.level"
                                        @change="matchInfoShow = false"
                                        ref="gameTypeRef"
                                    >
                                        <el-option
                                            v-for="item in dict_group"
                                            :key="item.dictCode"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" align="right">
                              <el-button
                                type="primary"
                                size="small"
                                style="width: 120px;"
                                @click="getMatchInfo()"
                                >确 认</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col style="display: flex; align-items: center;justify-content: space-between;">
                            <span>裁判功能</span>
                            <div style="font-size: 12px;">当前角色：<span class="role-cn">{{ roles[roleType].cn }}{{ roles[roleType].en }}</span><el-tag  type="primary" effect="dark" size="small" style="cursor: pointer;" @click="openNew">切换</el-tag></div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-button class="mb-18"
                            type="primary"
                            size="small"
                            plain
                            icon="el-icon-document-checked"
                            @click="showSignInInfoDialog()"
                            :disabled="!matchInfoShow"
                            >签到情况</el-button
                        >
                        <el-button class="mb-18"
                            type="primary"
                            size="small"
                            plain
                            icon="el-icon-s-data"
                            :disabled="!matchInfoShow"
                            @click="showRankInfoDialog()"
                            >实时排名</el-button
                        >
                        <el-button class="mb-18"
                            type="warning"
                            size="small"
                            plain
                            icon="el-icon-download"
                            :disabled="!matchInfoShow"
                            @click="downloadInfoList()"
                            >导出本轮晋级/淘汰名单</el-button
                        >
                      </el-row>
                      <el-row>
                        <!-- 总控可点 -->
                        <el-button
                            type="primary"
                            size="small"
                            icon="el-icon-setting"
                            :disabled="!matchInfoShow || roleType !== 1"
                            @click="showSetPromotionNumberDialog"
                            >设置晋级人数</el-button
                        >
                        <!-- 总控可点 -->
                        <el-button
                            type="danger"
                            size="small"
                            icon="el-icon-refresh"
                            :disabled="!matchInfoShow || roleType !== 1"
                            @click="resetAllRoundsDialogVisable = true"
                            >重置所有轮次</el-button
                        >
                        <!-- 中方 -->
                         <el-button
                            v-if="!isPause"
                            type="warning"
                            size="small"
                            icon="el-icon-video-pause"
                            :disabled="!matchInfoShow || roleType !== 2"
                            @click="matchPauseFn"
                            >暂停比赛</el-button
                        >
                        <el-button
                            v-if="isPause"
                            type="success"
                            size="small"
                            icon="el-icon-video-play"
                            :disabled="!matchInfoShow || roleType !== 2"
                            @click="matchContinue"
                            >继续比赛</el-button
                        >
                        <span class="pause-tip" v-if="matchInfoShow && isPause">
                          <i class="el-icon-loading"></i>
                          比赛暂停中
                        </span>
                        <template v-if="roleType === 1 || roleType === 2">
                          <el-switch v-model="autoRefresh" @change="startRefresh" style="margin-left: 10px;"></el-switch><span class="tip">自动刷新</span>
                        </template>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

        <el-tabs
            style="margin-top: 15px"
            class="cpxt"
            v-if="matchInfoShow"
            type="border-card"
            v-model="currentMatchInfoIndex"
            @tab-click="getMatchInfo('select')"
        >
            <el-tab-pane
                v-for="(item, i) in matchInfo"
                :label="'round' + item.round + '-' + item.roundName"
                :name="i + ''"
                :key="i"
            >
                <template slot="label">
                    <div
                        class="usual-tab-card"
                        :class="'usual-tab-card' + item.roundType"
                    >
                        {{ "round" + item.round + "-" + item.roundName }}
                    </div>
                </template>
                <el-row class="tab-headview">
                    <el-col
                        :span="16"
                        style="font-size: 16px"
                        v-if="item.roundType !== -110"
                    >
                        <span class="stas1"
                            >预晋级：<b>{{ statisticsInfo.setPassNum }}</b></span
                        >
                        <span class="stas1"
                            >已晋级：<b>{{ statisticsInfo.passedNum }}</b></span
                        >
                        <span class="stas2"
                            >本轮人数：<b>{{ statisticsInfo.curNum }}</b></span
                        >
                        <span class="stas2"
                            >本轮晋级：<b>{{ statisticsInfo.curPass }}</b></span
                        >
                        <span class="stas2"
                            >本轮淘汰：<b>{{ statisticsInfo.curOut }}</b></span
                        >
                        <span class="stas2"
                            >本轮待比赛：<b>{{ statisticsInfo.curWait }}</b></span
                        >
                    </el-col>
                    <el-col
                        :span="16"
                        style="font-size: 20px"
                        v-if="item.roundType === -110"
                    >
                        <span style="margin-left: 20px; color: #fdba01"
                            >参赛人数:{{ statisticsInfo.userNum }}</span
                        >
                        <span style="margin-left: 20px; color: #67c23a"
                            >晋级人数:{{ statisticsInfo.promotedNum }}</span
                        >
                        <span style="margin-left: 20px; color: #ff0000"
                            >淘汰人数:{{ statisticsInfo.notPromotedNum }}</span
                        >
                    </el-col>
                    <el-col
                        :span="7"
                        style="text-align: right"
                        v-if="item.roundType !== -110"
                    >
                        <el-button
                            type="warning"
                            size="small"
                            :disabled="!matchInfoShow || roleType !== 2"
                            @click="showPaperSetting"
                            >设置本轮试卷</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            @click="showSetPromotionDialog(item)"
                            v-if="showSetPromotionButton"
                            :disabled="roleType !== 1"
                            >设置晋级</el-button
                        >
                        <el-button
                            type="danger"
                            size="small"
                            @click="resetMatch(item)"
                            v-if="showBackButton"
                            :disabled="roleType !== 1"
                            >比赛回退</el-button
                        >
                    </el-col>
                </el-row>
                <el-table
                    ref="tableRef"
                    height="100%"
                    header-cell-class-name="tableHeaderStyle"
                    :data="showPlayers"
                    border
                    :row-class-name="tableRowClassName"
                    @expand-change="handleExpandChange"
                    :row-key="getRowKey"
                    :expand-row-keys="expandRows"
                >
                    <el-table-column type="expand">
                      <template slot-scope="scope">
                        <div class="panel11" :class="scope.row.answering ? 'panel-active' : ''">
                          <div class="panel-title" v-if="scope.row.answering">【{{ nationalnumFormatter(scope.row.competitionNumber) }}】{{ scope.row.userName }}正在作答 The current contestant
                            is competing</div>
                          <template v-if="scope.row.question">
                            <div class="word-row">
                              <div class="word">{{ scope.row.question.spell }}</div>
                              <div class="yinbiao">{{ scope.row.question.phonetic }}</div>
                              <i class="iconfont icon-yinpinaudio47 detail-icon" @click="handleToWordVoice(scope.row.question.purl)"></i>
                              <div style="display: flex; width: 600px;margin-left: 60px;" v-if="roleType === 2">
                                <el-input v-model="scope.row.userAnswer" size="small"
                                  style="width: 200px;margin-right: 10px;"></el-input>
                                <el-button type="primary" size="mini" style="margin-right: 60px;"
                                  @click="saveWord(scope.row)">保存</el-button>
                                <el-checkbox border label="正确" size="small" :class="scope.row.assistantPromoted === 1
                                    ? 'promoted-btn'
                                    : ''
                                  " v-model="scope.row.assistantPromoted" :true-label="1" false-label=""
                                  @change="assistantSet(scope.row, 1)">
                                </el-checkbox>
                                <el-checkbox border label="错误" size="small" :class="scope.row.assistantPromoted === 0
                                    ? 'eliminate-btn'
                                    : ''
                                  " v-model="scope.row.assistantPromoted" :true-label="0" false-label=""
                                  :style="{ '--fill-color': '#F56C6C' }" @change="assistantSet(scope.row, 0)">
                                </el-checkbox>
                              </div>
                            </div>
                            <div class="detail-flex">
                                <div class="detail-label">词性 Part of speech</div>
                                <div class="detail-value">{{ scope.row.question.partSpeech }}</div>
                            </div>
                            <div class="detail-flex" v-if="scope.row.question.origin">
                                <div class="detail-label">词源 Etymology</div>
                                <div class="detail-value">{{ scope.row.question.origin }}</div>
                            </div>
                            <div class="detail-flex">
                                <div class="detail-label">定义 Definition</div>
                                <i class="iconfont icon-yinpinaudio47 detail-icon" @click="handleToWordVoice(scope.row.question.durl)"></i>
                                <div class="detail-value">{{ scope.row.question.def }}</div>
                            </div>
                            <div class="detail-flex">
                                <div class="detail-label">例句 Sentence</div>
                                <i class="iconfont icon-yinpinaudio47 detail-icon" @click="handleToWordVoice(scope.row.question.eurl)"></i>
                                <div class="detail-value">{{ scope.row.question.exp }}</div>
                            </div>
                          </template>
                          <div class="tip" v-else>未设置 Not set</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column type="index" label="#"></el-table-column>
                    <template v-if="(roleType === 2 || roleType === 3) && item.roundType !== -110">
                      <el-table-column
                          label="单词 Word"
                          prop=""
                      >
                        <template slot-scope="scope">
                          <div class="spell2">
                            <template v-if=scope.row.question>
                              {{ scope.row.question.spell }}
                              <i class="iconfont icon-yinpinaudio47 detail-icon" @click="handleToWordVoice(scope.row.question.purl)"></i>
                            </template>
                            <div class="tip" v-else>未设置 Not set</div>
                            <span class="del" v-if="roleType === 2" @click="delAWord(scope.row)">修改单词</span>
                          </div>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column
                          label="状态 Status"
                      >
                        <template slot-scope="scope">
                          <el-tag v-if="scope.row.playerId === '36873'" type="primary" size="small">Answering in progress</el-tag>
                        </template>
                      </el-table-column> -->
                    </template>
                    <el-table-column
                        label="选手姓名 Name"
                        prop="userName"
                        align="center"
                    >
                        <template scope="scope">
                            <div class="nationalnum">{{ scope.row.userName }}</div>
                            <div class="">{{ scope.row.enName }}</div>
                        </template></el-table-column
                    >
                    <el-table-column
                        label="比赛号码牌 Number"
                        prop="competitionNumber"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div class="nationalnum">
                                {{ nationalnumFormatter(scope.row.competitionNumber) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="学校 School"
                        prop="schoolName"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="年级 Grade"
                        prop="grade"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                      v-if="roleType === 1"
                        label="中方记录"
                        prop="assistantPromoted"
                        align="center"
                    >
                      <template slot-scope="scope">
                        <div>{{ scope.row.userAnswer }}</div>
                        <el-tag v-if="scope.row.assistantPromoted || scope.row.assistantPromoted === 0" :type="scope.row.assistantPromoted === 1 ? 'success' : 'danger'" size="small" effect="dark">
                          {{ scope.row.assistantPromoted === 1 ? '正确' : '错误' }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="晋级 "
                        v-if="item.roundType !== -110 && roleType === 1"
                        width="160px"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-checkbox
                                border
                                label="晋级"
                                size="small"
                                :class="
                                    scope.row.promoted === '1'
                                        ? 'promoted-btn'
                                        : ''
                                "
                                v-model="scope.row.promoted"
                                true-label="1"
                                false-label=""
                                :key="scope.row.playerId"
                                @change="upDateStatisticsInfo(item, scope.row)"
                            >
                            </el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="淘汰"
                        v-if="item.roundType !== -110 && roleType === 1"
                        width="160px"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-checkbox
                                border
                                label="淘汰"
                                size="small"
                                :class="
                                    scope.row.promoted === '0'
                                        ? 'eliminate-btn'
                                        : ''
                                "
                                v-model="scope.row.promoted"
                                true-label="0"
                                false-label=""
                                :key="scope.row.playerId"
                                :style="{ '--fill-color': '#F56C6C' }"
                                @change="upDateStatisticsInfo(item, scope.row)"
                            >
                            </el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="晋级状态"
                        v-if="item.roundType === -110 || roleType === 0"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-tag
                                type="success"
                                v-if="scope.row.promoted === '1'"
                                >晋级</el-tag
                            >
                            <el-tag
                                type="danger"
                                v-else-if="scope.row.promoted === '0'"
                                >淘汰</el-tag
                            >
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="排名"
                        v-if="item.roundType === -110"
                        prop="promoted"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div
                                :class="
                                    scope.row.promoted === 1
                                        ? 'rank-success'
                                        : ''
                                "
                            >
                                {{ scope.row.ranking }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="名次"
                        v-if="item.roundType === -110"
                        prop="score_promoted"
                        align="center"
                    >
                        <!-- <template slot-scope="scope">
                            <div
                                :class="
                                    scope.row.promoted === 1
                                        ? 'rank-success'
                                        : ''
                                "
                            >
                                {{ scope.row.rankingName }}
                            </div>
                        </template> -->
                        <template slot-scope="scope">
                            <div
                                style="font-size: 16px; font-weight: 800"
                                :class="
                                    scope.row.rankingName === '冠军'
                                        ? 'guanjun'
                                        : scope.row.rankingName === '亚军'
                                        ? 'yajun'
                                        : scope.row.rankingName === '季军'
                                        ? 'jijun'
                                        : ''
                                "
                            >
                                {{ scope.row.rankingName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" v-if="roleType === 2" width="120px">
                        <template slot-scope="scope">
                            <el-button
                                type="success"
                                size="small"
                                :disabled="isPause || scope.row.answering || !scope.row.question"
                                @click="startFn(scope.row)"
                                >开始比赛</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-empty v-if="matchInfoShow && !matchInfo.length" :description="roleType === 1 ? '请设置晋级人数' : '请等待总控设置晋级人数'"></el-empty>
        </el-tabs>
        <audio ref="audioPlayer" @ended="overAudio"></audio>
        <!-- 暂停比赛 -->
        <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          :visible.sync="pauseVisible"
        >
          <div class="pause">
            <i class="el-icon-loading"></i>
            <div>比赛暂停</div>
            <div>Match suspended</div>
          </div>
        </el-dialog>
        <!-- 删除单词 -->
        <el-dialog
          title="修改单词"
          :visible.sync="delWordVisible"
          width="500px"
        >
          <div class="choose-title">{{ delItem.question ? '请选择修改方式，可手动挑词或删除，删除的单词放在试卷末尾，若原试卷中单词数量不足则无法删除。' : '该选手未分配单词，请手动选择单词。'}}</div>
          <div>
            <div class="choose-box" @click="changeWord">
              <div class="choose-box-title">手动挑词</div>
              <div class="choose-box-desc">选择本试卷或其他试卷内的单词。</div>
            </div>
            <template v-if="delItem.question">
              <div class="choose-box" @click="delFn(2)">
                <div class="choose-box-title">递补删除</div>
                <div class="choose-box-desc">删除本单词后，后续单词顺位向上补齐。</div>
              </div>
              <div class="choose-box" @click="delFn(1)">
                <div class="choose-box-title">单项删除</div>
                <div class="choose-box-desc">删除本单词后，在原试卷中随机抽取一个单词。</div>
              </div>
            </template>
          </div>
        </el-dialog>
        <!-- 更换单词 -->
        <el-dialog
          title="单词列表"
          :visible.sync="changeWordVisible"
          width="1000px"
        >
          <el-row>
            <el-col :span="3">
              <div class="left-tab-box">
                <div class="left-tab" :class="queryWordForm.paperId === item.id ? 'active' : ''" v-for="item in paperList" :key="item.id" @click="selectPaper(item.id)">{{ item.name }}({{ item.questionNum }})</div>
              </div>
            </el-col>
            <el-col :span="21">
              <div class="table-box">
                <div class="search-box">
                  <el-form ref="queryWordFormRef" :model="queryWordForm" label-width="80px">
                    <el-row>
                      <el-col :span="8" style="height: 44px;">
                        <el-form-item label="是否使用" prop="used">
                          <el-select size="small"
                              style="width: 100%"
                              v-model="queryWordForm.used"
                          >
                              <el-option label="已使用" :value="true"></el-option>
                              <el-option label="未使用" :value="false"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" style="height: 44px;">
                        <el-form-item label="状态" prop="deprecateState">
                          <el-select size="small"
                              style="width: 100%"
                              v-model="queryWordForm.deprecateState"
                          >
                              <el-option label="启用" :value="true"></el-option>
                              <el-option label="禁用" :value="false"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" style="height: 50px;" align="center">
                          <el-button type="primary" size="small" style="margin-top: 5px;" @click="getWordList">查询</el-button>
                          <el-button type="primary" size="small" plain @click="resetWordList">重置</el-button>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <div class="table-scroll">
                  <el-table style="margin-top: 10px;"
                      header-cell-class-name="tableHeaderStyle"
                      :data="wordList"
                      border
                      stripe
                  >
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="单词" prop="spell" width="160px">
                      <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-between;">
                          <span class="spell" :class="scope.row.used ? 'disabled' : ''">{{ scope.row.spell }}</span>
                          <el-tag type="warning" size="mini" v-if="scope.row.used">已使用</el-tag>
                          <el-button v-else type="primary" size="mini" :disabled="scope.row.used" @click="chooseWord(scope.row)">选择</el-button>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="定义" prop="def" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column label="例句" prop="exp" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column label="词性" prop="partSpeech"></el-table-column>
                    <el-table-column label="音标" prop="phonetic"></el-table-column>
                    <el-table-column label="词源" prop="origin"></el-table-column>
                    <el-table-column label="状态" prop="deprecateState" width="120px">
                      <template slot-scope="scope">
                        <el-tag style="margin-right: 10px;" size="mini" :type="scope.row.deprecateState ? 'success' : 'danger'">{{ scope.row.deprecateState ? '启用' : '禁用'}}</el-tag>
                        <el-switch
                          v-model="scope.row.deprecateState"
                          active-color="#13ce66"
                          inactive-color="#ff4949" @change="setWordState(scope.row, scope.row.deprecateState)">
                        </el-switch>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" fixed="right" width="160">
                      <template slot-scope="scope">
                        <el-button v-if="scope.row.deprecateState" type="success" size="mini" @click="setWordState(scope.row, false)">启用</el-button>
                        <el-button v-if="!scope.row.deprecateState" type="danger" size="mini" @click="setWordState(scope.row, true)">禁用</el-button>
                      </template>
                    </el-table-column> -->

                  </el-table>
                  <!-- 分页 -->
                  <div style="text-align: center;">
                    <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="queryWordForm.pageNum"
                        :page-sizes="[10, 20, 40, 80]"
                        :page-size="queryWordForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="wordTotal"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-dialog>
        <!-- 设置试卷 -->
        <el-dialog
          title="设置本轮试卷"
          :visible.sync="paperSetting"
          width="800px"
        >
          <div>
            <div class="paper-list">
              <el-row :gutter="12">
                <el-col :span="12" v-for="item in paperList" :key="item.id">
                  <div class="paper-item" :class="item.check ? 'b' : ''" @click="checkFn(item)">
                    <div class="paper-name">{{ item.name }}
                      <i class="paper-icon" :class="item.check ? 'check el-icon-success' : 'el-icon-circle-check'"></i>
                    </div>
                    <div class="flex">
                      <div>
                        <div class="paper-tit">试卷类型</div>
                        <div class="paper-value">{{ formatType(item.type) }}</div>
                      </div>
                      <div>
                        <div class="paper-tit">可用单词数量</div>
                        <div class="paper-value2">{{ item.questionNum }}</div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <el-form label-width="120px">
              <el-form-item label="试卷">
                <el-select multiple style="width: 300px;"
                    v-model="cityQuestionPaperIdList"
                >
                    <el-option
                        v-for="item in paperList"
                        :key="item.id"
                        :label="'【' + item.name + '】/' + formatType(item.type) + '/数量：' + item.questionNum"
                        :value="item.id"
                    ></el-option>
                </el-select>
              </el-form-item>
            </el-form> -->
            <div style="text-align: center;margin-bottom: 10px;">
                <el-button type="primary" @click="setPaperFn">确认选择</el-button>
            </div>
            <div class="tip red">*只给未设置晋级状态的选手匹配新的题目；优先使用被选中列表中靠前的试卷。</div>
          </div>
        </el-dialog>
        <!-- 切换角色 -->
        <el-dialog
            title="选择角色"
            :visible.sync="roleVisible"
            width="600px"
        >
            <div class="choose-title">请选择您的角色</div>
            <div>
              <div class="choose-box" :class="roleType === item.id ? 'active' : '' " @click="changeRoleFn(item.id)" v-for="(item,index) in roles" :key="index">
                <div class="choose-box-title">{{ item.cn }} {{ item.en }}</div>
                <div class="choose-box-desc">{{ item.desc }}</div>
              </div>
            </div>
            <div style="text-align: center;">
                <el-button type="primary" style="width: 160px;" @click="setRoleFn">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 使用说明 -->
        <el-dialog
            title="裁判系统使用说明"
            :visible.sync="descVisible"
            width="600px"
        >
          <div class="tab-desc">
              1、选择您的裁判角色。不同裁判角色有不同操作，请根据自身角色切换。
          </div>
          <div class="tab-desc">
              2、选择该场比赛的赛区和组别，并点击<span
                  style="color: rgb(64, 158, 255)"
                  >“确认”</span
              >按钮。
          </div>
          <div class="tab-desc">
              3、确认<span style="color: red">“签到结束”后</span
              >，设置晋级人数，系统自动生成第一轮比赛。
          </div>
          <div class="tab-desc">
              4、本轮比赛开始前【中方裁判】设置本轮比赛试卷。比赛中途如需更换试卷，已设置晋级/淘汰选手单词不变，只更改未作答选手单词。也可单独修改选手单词。
          </div>
          <div class="tab-desc">
              5、如遇上一轮比赛设置错误的情况。可点击<span
                  style="color: red"
                  >“比赛回退”</span
              >按钮回退上一轮比赛
          </div>
          <div class="tab-desc">
              6、发音官系统1s自动刷新一次；总控、中方裁判系统可按需自行设置自动刷新，20s/次。
          </div>
        </el-dialog>
        <!-- 查看签到情况的Dialog -->
        <el-dialog
            :title="'签到情况（已签到 ' + signInInfo.length + ' 人）'"
            :visible.sync="signInInfoDialogVisable"
            width="60%"
        >
            <el-table
                style="margin-top: 0"
                header-cell-class-name="tableHeaderStyle"
                :data="signInInfo"
                border
            >
                <el-table-column type="index"></el-table-column>
                <el-table-column
                    label="学校"
                    prop="schoolName"
                ></el-table-column>
                <el-table-column label="姓名" prop="name">
                    <template scope="scope">
                        <span
                            >{{ scope.row.userName }}
                            {{
                                scope.row.countryReserve === true
                                    ? "(保留)"
                                    : ""
                            }}</span
                        >
                    </template>
                </el-table-column>
                <el-table-column label="年级" prop="grade"></el-table-column>
                <el-table-column
                    label="比赛号码牌（上场顺序）"
                    prop="competitionNumber"
                    width="180px"
                >
                    <template scope="scope">
                        <span style="color: green; font-size: 18px">{{
                            scope.row.competitionNumber
                        }}</span>
                    </template></el-table-column
                >
                <el-table-column
                    label="性别"
                    prop="gender"
                    :formatter="genderFormatter"
                ></el-table-column>
            </el-table>
        </el-dialog>
        <!-- 设置晋级人数的Dialog -->
        <el-dialog
            title="设置晋级人数"
            :visible.sync="setPromotionNumberDialogVisable"
            width="500px"
        >
            <el-form label-width="80px">
                <el-form-item label="晋级人数">
                    <el-input
                        type="number"
                        v-model="promotionNum"
                        :disabled="!setPromotionNumberEnable"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span
                slot="footer"
                class="dialog-footer"
                v-if="setPromotionNumberEnable"
            >
                <el-button type="primary" @click="setPromotionNumber()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 设置晋级的Dialog -->
        <el-dialog
            title="设置晋级"
            :visible.sync="setPromotionDialogVisible"
            width="50%"
        >
            <div style="font-size: 18px">
                本轮为：{{ currentTurnName }} ，参赛人数：{{
                    currentTurnUserNum
                }}
            </div>
            <div style="color: #f56c6c; font-size: 18px; margin-top: 40px">
                本轮淘汰选手：{{ setPromotionTipsOut.length }} 人,
                {{ rankTitleStr }}
            </div>
            <el-row>
                <el-col
                    v-for="(item, index) in setPromotionTipsOut"
                    :key="index"
                    :span="6"
                >
                    <span style="color: #f56c6c"
                        ><span style="font-weight: bold">{{
                            item.competitionNumber
                        }}</span
                        >号-{{ item.userName }}</span
                    >
                </el-col>
            </el-row>
            <div style="color: #67c23a; margin-top: 40px; font-size: 18px">
                本轮晋级选手：{{ setPromotionTipsPass.length }} 人,
                {{ rankTitleStrJ }}
            </div>
            <el-row>
                <el-col
                    v-for="(item, index) in setPromotionTipsPass"
                    :key="index"
                    :span="6"
                >
                    <span style="color: #67c23a"
                        ><span style="font-weight: bold">{{
                            item.competitionNumber
                        }}</span
                        >号-{{ item.userName }}</span
                    >
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="danger"
                    v-if="setPromotionTipsPass.length > 1"
                    @click="promotTied()"
                    >并列晋级</el-button
                >
                <el-button @click="setPromotionDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="setPromotion()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 查看实时排名的Dialog -->
        <el-dialog
            title="实时排名"
            :visible.sync="showRealTimeRankingDialogVisable"
            width="60%"
        >
            <el-table
                style="margin-top: 0"
                header-cell-class-name="tableHeaderStyle"
                :data="rankInfo"
                border
            >
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column label="姓名" prop="userName"></el-table-column>
                <el-table-column
                    label="比赛号码牌"
                    prop="competitionNumber"
                    width="90px"
                >
                    <template slot-scope="scope">
                        <div class="nationalnum" style="color: red">
                            {{ scope.row.competitionNumber }}
                        </div>
                    </template></el-table-column
                >
                <el-table-column width="120px" label="手机号">
              <template slot-scope="scope">
                <MaskedPhone :phone="scope.row.phone" />
              </template>
            </el-table-column>
                <el-table-column
                    width="70px"
                    label="性别"
                    prop="sex"
                    :formatter="genderFormatter"
                ></el-table-column>
                <el-table-column
                    label="学校"
                    prop="schoolName"
                ></el-table-column>
                <el-table-column label="年级" prop="grade"></el-table-column>
                <el-table-column label="晋级状态" align="center">
                    <template slot-scope="scope">
                        <el-tag
                            type="danger"
                            v-if="scope.row.promoted === '0'"
                            size="mini"
                            >未晋级</el-tag
                        >
                        <el-tag
                            type="success"
                            v-else-if="scope.row.promoted === '1'"
                            size="mini"
                            >晋级</el-tag
                        >
                        <el-tag
                            type="success"
                            v-else-if="scope.row.promoted === '-1'"
                            size="warning"
                            >待比赛</el-tag
                        >
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="排名"
                    prop="promoted"
                    align="center"
                    width="100px"
                >
                    <template slot-scope="scope">
                        <div
                            :class="
                                scope.row.promoted === 1 ? 'rank-success' : ''
                            "
                        >
                            {{ scope.row.ranking }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="名次"
                    prop="score_promoted"
                    width="100"
                    align="center"
                >
                    <!-- <template slot-scope="scope">
                        <div
                            :class="
                                scope.row.promoted === 1 ? 'rank-success' : ''
                            "
                        >
                            {{ scope.row.rankingName }}
                        </div>
                    </template> -->
                    <template slot-scope="scope">
                        <div
                            style="font-size: 16px; font-weight: 800"
                            :class="
                                scope.row.rankingName === '冠军'
                                    ? 'guanjun'
                                    : scope.row.rankingName === '亚军'
                                    ? 'yajun'
                                    : scope.row.rankingName === '季军'
                                    ? 'jijun'
                                    : ''
                            "
                        >
                            {{ scope.row.rankingName }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 重置所有轮次 -->
        <el-dialog
            title="重置所有轮次"
            :visible.sync="resetAllRoundsDialogVisable"
            width="40%"
        >
            <el-form label-width="80px">
                <el-form-item label="输入密码">
                    <el-input type="text" v-model="password"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="resetAllRounds()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
  queryDistrictPage, setCityFinalRound, getPromotionNum, citySetPromotionNum, citySetPromotion, selectUserByRound, resetMatch,
  resetting, getMatchWinners, getSignInList, setPromotionPoint, setAbreastPromotion, getPromotionRanking
} from '@/http/api'
export default {
  data () {
    return {
      isRefresh: false,
      autoRefresh: false,
      timer: null,
      input: '',
      pauseVisible: false, // 控制弹窗
      isPause: false, // 控制按钮
      activeId: '',
      queryWordForm: {
        paperId: '',
        hallId: '',
        pageNum: 1,
        pageSize: 10,
        deprecateState: '',
        used: ''
        // thesaurusIdList: [],
        // syllables: '',
        // spell: '',
        // rankBegin: 1,
        // rankEnd: 50000,
        // numberofBeginLetters: 1,
        // numberofEndLetters: 5
      },
      wordList: [],
      wordTotal: 0,
      delWordVisible: false,
      delItem: {},
      changeWordVisible: false,
      paperList: [],
      cityQuestionPaperIdList: '',
      paperSetting: false,
      descVisible: false,
      roleType: 0,
      roleVisible: true,
      roles: [
        { id: 1, cn: '总控', en: 'Director', desc: '设置选手晋级/淘汰。' },
        { id: 2, cn: '中方裁判', en: 'Judger', desc: '1.设置试卷、选词；2.控制比赛开始/暂停；3.查看/修改单词；4.记录选手所拼单词' },
        { id: 3, cn: '发音官', en: 'Pronouncer', desc: '查看单词，给出当前选手发音。' },
        { id: 0, cn: '观赛者', en: 'Spectator', desc: '查看比赛进度、排行、选手晋级/淘汰；导出名单。' }
      ],
      expandRows: [], // 存放要展开的行的 key 值
      rankTitleStrJ: '',
      rankTitleStr: '',
      password: '',
      showPlayers: [],
      showRealTimeRankingDialogVisable: false,
      matchInfoShow: false,
      dict_group: this.$userInfo.dict_group(),
      dict_district: [],
      e_sex: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.e_sex = value }),
      dict_grade: this.$userInfo.getGradeData(),
      queryFormRule: {
        districtId: [{ required: true, message: '请选择', trigger: 'change' }],
        level: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        raceSchedule: this.$route.query.raceSchedule,
        matchTypeName: this.$route.query.matchTypeName,
        districtId: '',
        season: this.$chnEngStatusCode.defaultSeason,
        level: ''
      },
      resetAllRoundsDialogVisable: false,
      matchInfo: [],
      signInInfoDialogVisable: false,
      setPromotionNumberDialogVisable: false,
      promotionNum: 0,
      setPromotionNumberEnable: false,
      signInInfo: [],
      rankInfo: [],
      currentMatchInfoIndex: '',
      dict_season: [],
      statisticsInfo: {
        setPassNum: '',
        passedNum: '',
        curNum: '',
        curPass: '',
        curOut: '',
        curWait: ''
      },
      setPromotionDialogVisible: false,
      setPromotionTipsOut: [],
      setPromotionTipsPass: [],
      setPromotionData: [],
      questionPaper_type: this.$userInfo.questionPaper_type()
    }
  },
  created () {
    this.roleVisible = true
    this.getDistrictList()
    this.getSeason()
  },
  beforeDestroy () {
    this.stopRefresh()
  },
  methods: {
    getSeason () {
      this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => {
        this.dict_season = value
      })
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.roundType !== -110) {
        if (row.promoted === '0') {
          return 'warning-row'
        } else if (row.promoted === '1') {
          return 'success-row'
        } else if (row.answering) {
          return 'primary-row'
        } else {
          return ''
        }
      }
      return ''
    },

    openNew () {
      // 获取当前路由信息
      const { href } = this.$router.resolve({
        path: this.$route.path, // 当前路径
        query: this.$route.query, // 查询参数
        params: this.$route.params // 路由参数
      })
      // 在新窗口打开
      window.open(href, '_blank')
    },
    changeRoleFn (type) {
      this.roleType = type
    },
    formatType (type) {
      return type ? this.questionPaper_type.find(item => item.dictValue === type).dictLabel : ''
    },
    setRoleFn () {
      this.roleVisible = false
      this.queryForm.districtId = ''
      this.queryForm.level = ''
      this.matchInfoShow = false
      document.title = this.roles[this.roleType].cn + this.roles[this.roleType].en + '-裁判系统'
    },

    // 返回每行的唯一标识
    getRowKey (row) {
      return row.playerId
    },

    handleExpandChange (row, expandedRows) {
      if (row.answering) {
        this.$nextTick(() => {
          // 强制重新展开该行
          this.$refs.tableRef[0].toggleRowExpansion(row, true)
        })
        // this.$message.warning('正在答题选手不可收起')
      }
      this.expandRows = expandedRows.map(item => item.playerId)
      // console.log(expandedRows, this.expandRows)
    },

    goBack () {
      this.$router.back()
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    nationalnumFormatter (num) {
      return this.$xcUtils.addZero(num)
    },
    // 获取轮次信息
    getMatchInfo (flag) {
      if (flag === 'select') {
        this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
      } else {
        this.$refs.queryFormRef.validate(async valid => {
          if (!valid) return
          setCityFinalRound(this.queryForm).then((res) => {
            this.matchInfo = res.data
            if (this.matchInfo.length !== 0) {
              this.currentMatchInfoIndex = this.matchInfo.length - 1 + ''
              this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
            }
            if (this.matchInfo.length) {
              if (this.matchInfo[this.currentMatchInfoIndex].roundType !== -110) {
                // 刷新
                this.startRefresh()
              } else {
                this.stopRefresh()
              }
            }
            this.matchInfoShow = true
          }).catch((err) => {
            console.log('返回的err', err)
          })
        })
      }
    },
    startRefresh () {
      // 刷新频率：发音官1s，其他角色20s
      if (this.roleType === 3) {
        if (!this.isRefresh) {
          this.timer = setInterval(() => {
            this.getMatchInfo()
          }, 1000)
          this.isRefresh = true
        }
      } else {
        if (this.autoRefresh) {
          if (!this.isRefresh) {
            this.timer = setInterval(() => {
              this.getMatchInfo()
            }, 20000)
            this.isRefresh = true
          }
        } else {
          this.stopRefresh()
        }
      }
    },
    stopRefresh () {
      clearInterval(this.timer)
      this.timer = null
      this.isRefresh = false
    },
    showSignInInfoDialog () {
      this.queryForm.signIn = true
      getSignInList(this.queryForm).then((res) => {
        res.data.forEach(item => {
          item.competitionNumber = this.nationalnumFormatter(item.competitionNumber)
        })
        this.signInInfo = res.data
        this.signInInfoDialogVisable = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 查看实时排名
    showRankInfoDialog () {
      getMatchWinners(this.queryForm).then((res) => {
        this.rankInfo = res.data.winners
        this.rankInfo.forEach((item, index) => {
          item.promoted = item.promoted + ''
          item.competitionNumber = this.nationalnumFormatter(item.competitionNumber)
        })
        this.showRealTimeRankingDialogVisable = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },

    showSetPromotionNumberDialog () {
      getPromotionNum(this.queryForm).then((res) => {
        this.promotionNum = res.data.promotionNum
        if (this.promotionNum < 1) {
          this.promotionNum = 0
          this.setPromotionNumberEnable = true
        } else {
          this.setPromotionNumberEnable = false
        }
        this.setPromotionNumberDialogVisable = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    setPromotionNumber () {
      if (this.promotionNum === 0) {
        return this.$message.warning('晋级人数不能为0')
      }
      this.queryForm.promotionNum = this.promotionNum
      citySetPromotionNum(this.queryForm).then((res) => {
        this.$message.success('设置成功')
        this.getMatchInfo()
        this.setPromotionNumberDialogVisable = false
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    genderFormatter (data) {
      var temp = '未设置'
      for (const key in this.e_sex) {
        if (Object.hasOwnProperty.call(this.e_sex, key)) {
          const element = this.e_sex[key]
          console.log('element.dictValue', element.dictValue)
          if (element.dictValue + '' === data.sex + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    showSetPromotionDialog (data) {
      this.setPromotionDataRequest(data)
    },
    // 处理晋级数据
    setPromotionDataRequest (data) {
      console.log('this.showPlayers', this.showPlayers)
      // 检查是否所有选手都设置了晋级状态
      var temp = []
      this.showPlayers.forEach(element => {
        if (element.promoted === '-1' || element.promoted === '') {
          temp.push(element)
        }
      })
      if (temp.length > 0) {
        var tempStr = ''
        temp.forEach(element => {
          tempStr += element.competitionNumber + '号-' + element.userName + '<br>'
          // tempStr += `${element.competitionNumber}号-${element.userName}`
        })
        return this.$alert(tempStr, '存在选手未设置晋级', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true
        })
      }
      // 再次确认本轮晋级情况
      // 初始化数据
      this.setPromotionTipsOut = []
      this.setPromotionTipsPass = []
      this.showPlayers.forEach(element => {
        if (element.promoted === '1') {
          this.setPromotionTipsPass.push(element)
        }
        if (element.promoted === '0') {
          this.setPromotionTipsOut.push(element)
        }
      })
      this.setPromotionData = data
      this.getEliminationRankingInformation()
    },

    // 获取淘汰排名信息
    getEliminationRankingInformation () {
      var playerIds = [] // 晋级比赛选手id
      this.showPlayers.forEach(element => {
        if (element.promoted === '1') {
          playerIds.push(element.playerId)
        }
      })
      this.queryForm.playerIds = playerIds
      this.queryForm.finalMatchId = this.setPromotionData.id
      getPromotionRanking(this.queryForm).then((res) => {
        if (res.data.notPromotionRanking) {
          this.rankTitleStr = '获得名次：第' + res.data.notPromotionRanking + '名'
        } else {
          this.rankTitleStr = ''
        }
        if (res.data.promotionRanking) {
          this.rankTitleStrJ = '获得名次：第' + res.data.promotionRanking + '名'
        } else {
          this.rankTitleStrJ = ''
        }
        this.setPromotionDialogVisible = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    setPromotion (flag) {
      var playerIds = [] // 晋级比赛选手id
      this.showPlayers.forEach(element => {
        if (element.promoted === '1') {
          playerIds.push(element.playerId)
        }
      })
      this.queryForm.playerIds = playerIds
      this.queryForm.finalMatchId = this.setPromotionData.id
      if (flag === 'promotTied') {
        setAbreastPromotion(this.queryForm).then((res) => {
          this.$curUtils.closeLoading(this)
          this.$message.success('设置晋级成功')
          this.setPromotionDialogVisible = false
          this.getMatchInfo()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      } else {
        citySetPromotion(this.queryForm).then((res) => {
          this.$curUtils.closeLoading(this)
          this.$message.success('设置晋级成功')
          this.setPromotionDialogVisible = false
          this.getMatchInfo()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      }
    },
    upDateStatisticsInfo (data, rowData) {
      // console.log('data', rowData)
      this.statisticsInfo.setPassNum = data.finalMathPromotedNum
      this.statisticsInfo.passedNum = data.winnwePromotedNum
      this.statisticsInfo.curNum = 0
      this.statisticsInfo.curPass = 0
      this.statisticsInfo.curOut = 0
      this.statisticsInfo.curWait = 0
      this.showPlayers.forEach(element => {
        this.statisticsInfo.curNum++
        if (element.promoted === '1') {
          this.statisticsInfo.curPass++
        } else if (element.promoted === '0') {
          this.statisticsInfo.curOut++
        } else {
          this.statisticsInfo.curWait++
        }
      })
      console.log(rowData)
      if (rowData) {
        this.setPromotedData(rowData)
      }
    },
    async setPromotedData (rowData) {
      if (rowData.promoted === '') {
        rowData.promoted = '-1'
      }
      console.log('this.queryForm', this.queryForm)
      setPromotionPoint({
        ...this.queryForm,
        ...{
          playerId: rowData.playerId,
          promoted: rowData.promoted
        }
      }).then((res) => {
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 获取轮次下指定选手列表
    getRoundPlayerInfo (showSchedule) {
      // console.log('showSchedule', showSchedule)
      if (showSchedule.roundType === -110) { // 晋级名单单独处理
        getMatchWinners(this.queryForm).then((res) => {
          this.showPlayers = res.data.winners.map(item => {
            item.promoted = item.promoted + ''
            return item
          })
          this.statisticsInfo.userNum = res.data.userNum
          this.statisticsInfo.promotedNum = res.data.promotedNum
          this.statisticsInfo.notPromotedNum = res.data.notPromotedNum
        }).catch((err) => {
          console.log('返回的err', err)
        })
      } else {
        selectUserByRound({ finalMatchId: showSchedule.id }).then((res) => {
          this.showPlayers = res.data.map(item => {
            item.promoted = item.promoted + ''
            return item
          })

          // 如果有正在作答的选手，关闭正在作答的选手的上一个词，不关闭手动打开的词
          if (this.showPlayers.find(item => item.answering)) {
            const lastIndex = this.showPlayers.findIndex(item => item.answering) - 1
            if (lastIndex > -1) {
              const delId = this.showPlayers[lastIndex].playerId
              this.expandRows = this.expandRows.filter(pid => pid !== delId)
            } // 关闭上一个
            this.expandRows.push(this.showPlayers.find(item => item.answering).playerId) // 展开正在答题的
            this.expandRows = [...new Set(this.expandRows)] // 数组去重
          }
          // console.log('expandRows===', this.expandRows)

          this.upDateStatisticsInfo(showSchedule)
          const cityRefereeHallStatue = res.data[0].cityRefereeHallStatue
          this.isPause = cityRefereeHallStatue === 2
          this.pauseVisible = this.roleType === 3 && cityRefereeHallStatue === 2
        }).catch((err) => {
          console.log('返回的err', err)
        })
      }
    },
    matchOver () {
      this.$confirm('比赛结束将由“已晋级选手”和“本轮晋级选手”直接生成晋级名单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setPromotion('matchOver')
      })
    },
    resetMatch (item) {
      this.$confirm('比赛回退将重新返回上一轮比赛未设置晋级的状态, 是否确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.queryForm.finalMatchId = item.id
        resetMatch(this.queryForm).then((res) => {
          this.$message.success('比赛回退成功')
          this.getMatchInfo()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    promotTied () {
      this.$confirm('并列晋级将由“本轮晋级选手”并列排名晋级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setPromotion('promotTied')
      })
    },
    // 下载签到表
    downloadInfoList () {
      var downLoadUrl = ''
      if (this.matchInfo[this.currentMatchInfoIndex].roundType === -110) {
        downLoadUrl = this.$env.baseIP + 'cityMatch/final/exportMatchWinners'
      } else {
        downLoadUrl = this.$env.baseIP + 'cityMatch/final/excelUserByRound'
      }
      this.queryForm.finalMatchId = this.matchInfo[this.currentMatchInfoIndex].id
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', this.queryForm)
    },
    // 重置所有轮次
    resetAllRounds () {
      if (this.password !== '1qazxsw2cz') {
        return this.$message.error('密码错误！')
      }
      this.queryForm.password = this.password
      resetting(this.queryForm).then((res) => {
        this.resetAllRoundsDialogVisable = false
        this.getMatchInfo()
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    syllablesFormat (data) {
      return data.syllables === 1 ? '单音节' : data.syllables === 2 ? '多音节' : ''
    },
    showPaperSetting () {
      this.$http.get('cityQuestionPaper/getDistrictCityQuestionPaperPage', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.paperList = res.data
          this.paperSetting = true
        }
      })
    },
    startFn (data) {
      this.expandRows = []
      this.$http.post('cityMatch/final/setAnswering', { ...this.queryForm, ...{ playerId: data.playerId } }).then(res => {
        if (res.code === 200) {
          this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
        }
      })
    },
    changeWord () {
      this.$http.get('cityQuestionPaper/getDistrictCityQuestionPaperPage', { params: { ...this.queryForm, ...{ playerId: this.delItem.playerId } } }).then(res => {
        if (res.code === 200 && res.data.length) {
          this.paperList = res.data
          this.changeWordVisible = true
          this.delWordVisible = false
          if (res.data.find(item => item.useding)) {
            this.queryWordForm.paperId = res.data.find(item => item.useding).id
          } else {
            this.queryWordForm.paperId = res.data[0].id
          }
          this.getWordList()
        } else {
          this.$message.warning('暂无单词数据')
        }
      })
    },
    selectPaper (id) {
      this.queryWordForm.pageNum = 1
      this.queryWordForm.pageSize = 20
      this.queryWordForm.paperId = id
      this.getWordList()
    },
    delFn (type) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('cityMatch/final/deletePlayerQuestion', {
          ...this.queryForm,
          ...{ delType: type, playerId: this.delItem.playerId, questionDistrictJoinId: this.delItem.question.questionId }
        }).then(res => {
          if (res.code === 200) {
            this.delWordVisible = false
            this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
          }
        })
      }).catch(() => {
      })
    },
    delAWord (data) {
      this.delItem = data
      this.queryWordForm.hallId = data.hallId
      this.queryWordForm.pageNum = 1
      this.queryWordForm.pageSize = 10
      this.delWordVisible = true
    },
    // 禁用单词
    setWordState (item, type) {
      this.$http.post('cityMatch/final/updateMatchQuestionDeprecateState', {
        ...this.queryForm,
        ...{ hallId: this.queryWordForm.hallId, paperId: this.queryWordForm.paperId, questionId: item.id, deprecateState: type }
      }).then(res => {
        if (res.code === 200) {
          this.getWordList()
        }
      })
    },
    // 选择单词
    chooseWord (item) {
      this.$http.post('cityMatch/final/citySetUserWord', {
        ...this.queryForm,
        ...{ finalMatchId: this.matchInfo[this.currentMatchInfoIndex].id, cityPlayerId: this.delItem.playerId, questionId: item.id }
      }).then(res => {
        if (res.code === 200) {
          this.changeWordVisible = false
          this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
        }
      })
    },
    resetWordList () {
      this.$refs.queryWordFormRef.resetFields()
      this.queryWordForm.pageNum = 1
      this.queryWordForm.pageSize = 10
      this.getWordList()
    },
    handleSizeChange2 (newSize) {
      this.queryWordForm.pageSize = newSize
      this.getWordList()
    },
    handleCurrentChange2 (newCurPage) {
      this.queryWordForm.pageNum = newCurPage
      this.getWordList()
    },
    getWordList () {
      // this.queryWordForm.thesaurusIdList = [this.activeId]
      this.$http.get('cityQuestionPaper/getMatchQuestionPage', { params: { ...this.queryWordForm, ...this.queryForm } }).then(res => {
        if (res.code === 200) {
          this.wordList = res.data.list
          this.wordTotal = res.data.total
        }
      })
    },
    // 继续比赛
    matchContinue () {
      this.changeMatchStatus(1).then(res => {
        if (res.code === 200) {
          this.getMatchInfo()
        }
      })
    },
    // 暂停比赛
    matchPauseFn () {
      this.changeMatchStatus(2).then(res => {
        if (res.code === 200) {
          this.getMatchInfo()
        }
      })
    },
    // 0:未开始 1:比赛中 2:暂停 3:已结束
    async changeMatchStatus (status) {
      const formData = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        raceSchedule: this.queryForm.raceSchedule,
        districtId: this.queryForm.districtId,
        level: this.queryForm.level,
        status
      }
      return await this.$http.post('cityMatch/final/setHallStatus', formData)
    },
    // 保存选手答案
    saveWord (data) {
      if (data.userAnswer) {
        this.$http.post('cityMatch/final/saveUserAnswer', {
          ...this.queryForm,
          ...{ userAnswer: data.userAnswer, id: data.playerId, playerQuestionId: data.question.id }
        }).then(res => {
          if (res.code === 200) {
            this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
          }
        })
      }
    },
    // 中方裁判记录对错
    assistantSet (data, type) {
      this.$http.post('cityMatch/final/setAssistantPromotion', { ...this.queryForm, ...{ playerId: data.playerId, assistantPromoted: type } }).then(res => {
        if (res.code === 200) {
          this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
        }
      })
    },
    // 设置本轮试卷
    setPaperFn () {
      this.cityQuestionPaperIdList = this.paperList.filter(item => item.check).map(item => item.id)
      if (!this.cityQuestionPaperIdList.length) {
        return this.$message.warning('请选择试卷')
      }
      this.$http.post('cityMatch/final/citySetUsersWords', {
        ...this.queryForm,
        ...{
          finalMatchId: this.matchInfo[this.currentMatchInfoIndex].id,
          cityQuestionPaperIdList: this.cityQuestionPaperIdList
        }
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('设置成功')
          this.getMatchInfo()
          this.paperSetting = false
        }
      })
    },
    // 单词点击事件
    handleToWordVoice (voiceUrl) {
      this.$refs.audioPlayer.src = voiceUrl
      this.$refs.audioPlayer.play()
    },
    overAudio () {

    },
    checkFn (item) {
      this.$set(item, 'check', !item.check)
    }
  },
  computed: {
    showSetPromotionButton () {
      // var schduleArray = []
      // for (let index = 0; index < this.matchInfo.length; index++) {
      //   const element = this.matchInfo[index]
      //   if (element.roundType !== -110) {
      //     schduleArray.push(element)
      //   }
      // }
      return (Number(this.currentMatchInfoIndex) === this.matchInfo.length - 1 && this.matchInfo[this.matchInfo.length - 1].roundType !== -110)
    },
    showBackButton () {
      // var schduleArray = []
      // for (let index = 0; index < this.matchInfo.length; index++) {
      //   const element = this.matchInfo[index]
      //   if (element.roundType !== -110) {
      //     schduleArray.push(element)
      //   }
      // }
      return (Number(this.currentMatchInfoIndex) === this.matchInfo.length - 1) && (Number(this.currentMatchInfoIndex) !== 0)
    },
    currentTurnName () {
      if (this.matchInfo[this.currentMatchInfoIndex] !== undefined) {
        return this.matchInfo[this.currentMatchInfoIndex].roundName
      }
      return ''
    },
    currentTurnUserNum () {
      if (this.showPlayers) {
        return this.showPlayers.length
      }
      return ''
    }

  }
}
</script>

<style lang="less" scoped>
.el-tab-pane {
    height: calc(100vh - 110px);
    overflow-y: auto;
}
.el-table {
    margin-top: 48px;
    z-index: 99;
}
.tab-headview {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100;
    background-color: white;
    padding: 12px 0px;
    line-height: 36px;
}
.stas1{
  margin-left: 20px;
  font-size: 12px;
  b{
    color: #67C23A;
    font-size: 18px;
    font-weight: bold;
  }
}
.stas2{
  margin-left: 20px;
  font-size: 12px;
  b{
    color: #409EFF;
    font-size: 18px;
    font-weight: bold;
  }
}
.nationalnum {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    letter-spacing: 1px;
}

.guanjun {
    color: #ffae5d;
}
.yajun {
    color: #cccccc;
}
.jijun {
    color: #b86d29;
}
.tab-desc {
    font-size: 14px;
    margin-bottom: 6px;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-right-color: transparent;
    border-left-color: transparent;
    height: 50px;
    line-height: 56px;
    // background: #409EFF;
    color: #fff;
    font-size: 18px;
    border-radius: 20px 20px 0 0;
    .usual-tab-card {
        background: #409eff;
        padding-left: 24px;
        padding-right: 24px;
    }
}
.role-cn{
  font-size: 14px;
  font-weight: bold;
  color: #409eff;
  margin-right: 10px;
}
.role-desc{
  font-size: 12px;
  color: #6e6e6e;
  margin-left: 5px;
  margin-bottom: 25px;
  display: block;
  height: 32px;
}
.mb-18{
  margin-bottom: 18px;
}
.spell2{
  font-size: 18px;
  color: #409eff;
  font-weight: bold;
  .del{
    color: #F56C6C;
    font-size: 12px;
    font-weight: normal;
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;
    &:hover{
      font-weight: bold;
    }
  }
}
.spell2 .tip, .tip{
  font-size: 12px;
  font-weight: normal;
  color: #909399;
  display: inline-block;
}
.red{
  color: #f00 !important;
  text-align: center;
  width: 100%;
}

/* 替换展开图标 */
/deep/ .el-table__expand-icon {
  /* 隐藏原有图标 */
  -webkit-font-smoothing: antialiased;
}

/deep/ .el-table__expand-icon .el-icon-arrow-right:before {
  /* 使用自定义图标，例如使用 Element UI 的其他图标 */
  content: "\e6c5"; /* 替换为想要的图标编码 */
}

/* 或者完全替换为自定义样式 */
/deep/ .el-table__expand-icon {
  position: relative;
}

/deep/ .el-table__expand-icon .el-icon-arrow-right {
  display: none;
}

/deep/ .el-table__expand-icon:before {
  content: "▶"; /* 自定义字符图标 */
  font-size: 18px;
  color: #409eff;
}

/deep/ .el-table__expand-icon--expanded:before {
  transform: rotate(90deg);
}
.panel11{
    background-color: #F4F4F5;
    padding: 20px 20px 20px 104px;
    &.panel-active{
        background-color: #ECF5FF;
    }
    .panel-title{
      color: #67C23A;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
    }
}
.word-row{
    display: flex;
    align-items: center;
}
.word{
    color: #000;
    font-size: 22px;
    font-weight: bold;
}
.yinbiao{
    font-size: 16px;
    font-weight: bold;
    margin-left: 8px;
    color: #909399;
    // background-color: #409eff;
    width: fit-content;
    padding: 0 6px;
}
.detail-flex{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 18px;
    .detail-label{
      width: 90px;
      font-size: 12px;
      margin-right: 10px;
      width: 136px;
      padding: 2px 12px;
      color: #fff;
      background: #909399;
    }
    .detail-value{
      flex: 1;
      font-size: 14px;
      color: #000;
    }
}
.detail-icon{
    font-size: 14px;
    cursor: pointer;
    color: #909399;
    margin-left: 10px;
    margin-right: 10px;
    &:hover{
        color: #409eff;
    }
}
.panel-active .detail-flex .detail-label{
    background-color: #409EFF;
}

.choose-title{
  font-size: 14px;
  color: #000;
  margin-bottom: 20px;
}
.choose-box{
  border: 1px solid #B3D8FF;
  color: #000;
  padding: 12px 24px;
  margin-bottom: 20px;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  .choose-box-title{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 6px;
  }
  .choose-box-desc{
    font-size: 12px;
    color: #909399;
  }
  &:hover, &.active{
    background-color: #ECF5FF;
    .choose-box-title{
        color: #409EFF;
    }
  }
}

.left-tab-box{
  border-right: 2px solid #E4E7ED;
  padding-right: 10px;
}
.left-tab{
  font-size: 12px;
  color: rgb(64, 158, 255);
  // background: rgb(236, 245, 255);
  border: 1px solid rgb(179, 216, 255);
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 6px 12px;
  overflow-wrap: break-word;
  word-break: normal;
  cursor: pointer;
  &.active{
    color: #fff;
    background: rgb(64, 158, 255);
    border-color:rgb(64, 158, 255);
  }
}
.search-box{
  background-color: #eff6fe;
  padding: 10px 0 0;
}
.table-box{
  margin-left: 10px;
}
.spell{
  color: #67C23A;
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
  &.disabled{
    color: #909399;
  }
}
.table-scroll{
  height: calc(100vh - 300px);
  overflow-y: auto;
}

.pause{
  text-align: center;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #409EFF;
  font-size: 18px;
  font-weight: bold;
  i{
    font-size: 30px;
    display: block;
    margin-bottom: 20px;
  }
}
.pause-tip{
  color: #409EFF;
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
}
.paper-item{
  background-color: #F2F6FC;
  margin-bottom: 12px;
  border-radius: 10px;
  border: 2px solid transparent;
  .paper-name{
    font-size: 16px;
    color: #000;
    padding: 8px 30px 8px 12px;
    background-color: #C6E2FF;
    border-radius: 10px 10px 0 0;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .paper-icon{
      position: absolute;
      right: 8px;
      top: 10px;
      color: #909399;
      font-size: 18px;
      cursor: pointer;
    }
    .check{
      color: #409EFF;
    }
  }
  .flex{
    display: flex;
    padding: 10px;
    justify-content: space-between;
    .paper-tit{
      font-size: 12px;
      margin-bottom: 4px;
      color: #909399;
    }
    .paper-value{
      font-size: 12px;
      color: #000;
      text-align: center;
    }
    .paper-value2{
      font-size: 18px;
      color: #409EFF;
      text-align: center;
    }
  }
  &.b{
    border-color: #409EFF;
  }
}
</style>
